module.exports = __webpack_public_path__ + "img/shiba-head-level7.b7be7433.png";